import type { IIapProductCurrency, IIapProductPrice } from './IapProductsData';

export type IIapCountryCode = 'us' | 'fr';

const currencyByCountryCode: Record<IIapCountryCode, IIapProductCurrency> = {
  us: 'usd',
  fr: 'usd',
};

export const getFormattedIapProductPrice = (
  price: IIapProductPrice,
  countryCode: IIapCountryCode = 'us',
): string => {
  const currency = currencyByCountryCode[countryCode ?? 'us'];

  return new Intl.NumberFormat(countryCode, {
    style: 'currency',
    currency,
  }).format(price[currency] / 1000000);
};
